import { render, staticRenderFns } from "./institutionModal.vue?vue&type=template&id=2297366a&scoped=true"
import script from "./institutionModal.vue?vue&type=script&lang=js"
export * from "./institutionModal.vue?vue&type=script&lang=js"
import style0 from "./institutionModal.vue?vue&type=style&index=0&id=2297366a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297366a",
  null
  
)

export default component.exports